import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Simple module-level cache so we only fetch once per page load.
let cached = null;
let inflight = null;
const listeners = new Set();

async function fetchSold() {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = fetch(`${BACKEND}/api/artwork-status`)
    .then((r) => (r.ok ? r.json() : { sold: [] }))
    .then((j) => new Set(j.sold || []))
    .catch(() => new Set())
    .finally(() => {
      inflight = null;
    });
  cached = await inflight;
  return cached;
}

export function invalidateArtworkStatusCache() {
  cached = null;
  for (const cb of listeners) cb();
}

// Returns true if the given slug is currently marked as sold.
export function useArtworkSold(slug) {
  const [sold, setSold] = useState(() => (cached ? cached.has(slug) : false));

  useEffect(() => {
    let alive = true;
    const update = () => {
      if (alive && cached) setSold(cached.has(slug));
    };
    listeners.add(update);
    fetchSold().then(update);
    return () => {
      alive = false;
      listeners.delete(update);
    };
  }, [slug]);

  return sold;
}

// Returns the full Set<string> of sold slugs (readonly).
export function useSoldSlugs() {
  const [set, setSet] = useState(() => cached || new Set());

  useEffect(() => {
    let alive = true;
    const update = () => {
      if (alive && cached) setSet(new Set(cached));
    };
    listeners.add(update);
    fetchSold().then(update);
    return () => {
      alive = false;
      listeners.delete(update);
    };
  }, []);

  return set;
}
